import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import * as actions from '@actions';
import useIsRestricted from './useIsRestricted';

export const usePatientVirtualOnly = (caseId: number) => {
  const dispatch = useDispatch();
  const isRestricted = useIsRestricted();

  const eligibilityQuery = useQuery({
    queryKey: ['patientVirtualOnly', caseId],
    queryFn: () => dispatch(actions.getCaseEligibility(caseId)),
    select: (data: any) => {
      const eligibilityBlock = data?.case_eligibility?.[0];
      const eligibility = eligibilityBlock?.eligibility?.[0];

      return {
        isVirtualOnly: eligibility?.VIRTUAL_ONLY === 'true',
        reason: eligibilityBlock?.virtual_only_reason || ''
      };
    },
    enabled: !!caseId && !isRestricted,
    staleTime: 5 * 60 * 1000
  });

  return {
    isVirtualOnly: eligibilityQuery.data?.isVirtualOnly,
    reason: eligibilityQuery.data?.reason || null,
    isLoading: eligibilityQuery.isLoading
  };
};
